import { apiKeysCRUDActions } from '../actions/ApiKeysCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, update } from './common/commonReducers';
import { ApiKeyModel } from '../model/ApiKeyModel';
import { ApiKeysState } from '../interfaces/apiKeys';

const initialState: ApiKeysState = {
  busy: false,
  entities: [],
};

export default function forms(
  state: ApiKeysState = initialState,
  action,
): ApiKeysState {
  switch (action.type) {
    case apiKeysCRUDActions.busyAction:
      return setBusy(state);
    case apiKeysCRUDActions.unbusyAction:
      return setUnBusy(state);
    case apiKeysCRUDActions.updateAction:
      return update(state, action);
    case apiKeysCRUDActions.retrievedAction: {
      const { entity: newApiKey } = action;
      let entities = state.entities;

      if (state.entities) {
        const idx = state.entities.findIndex(c => c.id === newApiKey.id);

        if (idx !== -1) {
          entities = [
            ...state.entities.slice(0, idx),
            newApiKey,
            ...state.entities.slice(idx + 1),
          ];
        } else {
          entities = [...state.entities, newApiKey];
        }
      }

      return {
        ...state,
        busy: false,
        entities,
      };
    }

    case apiKeysCRUDActions.deleteLocalAction: {
      const { id: apiKeyId } = action.entity as ApiKeyModel;
      const entities = state.entities
        ? state.entities.filter(k => k.id !== apiKeyId)
        : state.entities;
      return {
        ...state,
        busy: false,
        entities,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    case apiKeysCRUDActions.retrievedAllAction: {
      return {
        ...state,
        busy: false,
        entities: action.entities,
      };
    }

    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
